import React, { useEffect, useState } from 'react'

import Arrow from '../../../images/arrow-right.png'

const AddToCartForm = ({ productData, onChangeVariant }) => {
  const [selectedSize, setSelectedSize] = useState()
  const [selectedFit, setSelectedFit] = useState()
  const [selectedColor, setSelectedColor] = useState()
  const [
    availableColorsForSelectedOption,
    setAvailableColorsForSelectedOption,
  ] = useState([])
  const [availableSizesForSelectedOption, setAvailableSizesForSelectedOption] =
    useState([])
  const [availableFitsForSelectedOption, setAvailableFitsForSelectedOption] =
    useState([])
  const [selectedVariant, setSelectedVariant] = useState()
  const [hasMultipleVariants, setHasMultipleVariants] = useState(false)
  const [isSimpleProduct, setIsSimpleProduct] = useState(false)
  const [isAddingCart, setIsAddingCart] = useState(false)

  useEffect(() => {
    if (productData.options[0].name !== 'Title') {
      productData.options.map((option, index) => {
        if (option.name === 'Size') {
          setSelectedSize(productData.variants[0].options[index])
        } else if (option.name === 'Color') {
          setSelectedColor(productData.variants[0].options[index])
        } else if (option.name === 'Fit') {
          setSelectedFit(productData.variants[0].options[index])
        }
      })
    } else {
      setSelectedVariant(productData.variants[0])
      onChangeVariant(productData.variants[0])
    }

    setIsSimpleProduct(productData.options[0].name === 'Title')
    setHasMultipleVariants(productData.options.length > 1)
  }, [])

  const onSelectSize = (size) => {
    if (hasMultipleVariants && availableSizesForSelectedOption.includes(size)) {
      setSelectedSize(size)
    } else if (!hasMultipleVariants) {
      setSelectedSize(size)
    }
  }

  const onSelectColor = (color) => {
    if (
      hasMultipleVariants &&
      availableColorsForSelectedOption.includes(color)
    ) {
      setSelectedColor(color)
    } else if (!hasMultipleVariants) {
      setSelectedColor(color)
    }
  }

  const onSelectFit = (fit) => {
    if (hasMultipleVariants && availableFitsForSelectedOption.includes(fit)) {
      setSelectedFit(fit)
    } else if (!hasMultipleVariants) {
      setSelectedFit(fit)
    }
  }

  useEffect(() => {
    if (
      productData.options[0].name !== 'Title' &&
      (selectedSize || selectedColor || selectedFit)
    ) {
      let sizeOptionIndex = -1
      let colorOptionIndex = -1
      let fitOptionIndex = -1

      productData.options.map((option, index) => {
        if (option.name === 'Size') {
          sizeOptionIndex = index
        } else if (option.name === 'Color') {
          colorOptionIndex = index
        } else if (option.name === 'Fit') {
          fitOptionIndex = index
        }
      })

      const variant = productData.variants.find((variant) => {
        let isSameSize = false
        let isSameColor = false
        let isSameOptions = false
        let isSameFit = false

        if (
          selectedSize &&
          sizeOptionIndex > -1 &&
          variant.options[sizeOptionIndex] === selectedSize
        ) {
          isSameSize = true
        }
        if (
          selectedColor &&
          colorOptionIndex > -1 &&
          variant.options[colorOptionIndex] === selectedColor
        ) {
          isSameColor = true
        }

        if (
          selectedFit &&
          fitOptionIndex > -1 &&
          variant.options[fitOptionIndex] === selectedFit
        ) {
          isSameFit = true
        }

        if (selectedSize && selectedColor && selectedFit) {
          isSameOptions = isSameSize && isSameColor && isSameFit
        } else {
          isSameOptions = isSameColor || isSameSize || isSameFit
        }
        return isSameOptions
      })

      setSelectedVariant(variant)
      onChangeVariant(variant)
      //find available options
      if (productData.options.length > 1) {
        let variantsForSelectedSizeOption = []
        let variantsForSelectedColorOption = []
        let variantsForSelectedFitOption = []
        productData.variants.map((variant) => {
          if (
            selectedSize &&
            variant.options[sizeOptionIndex] === selectedSize
          ) {
            variantsForSelectedSizeOption = [
              ...variantsForSelectedSizeOption,
              variant,
            ]
          }

          if (
            selectedColor &&
            variant.options[colorOptionIndex] === selectedColor
          ) {
            variantsForSelectedColorOption = [
              ...variantsForSelectedColorOption,
              variant,
            ]
          }

          if (selectedFit && variant.options[fitOptionIndex] === selectedFit) {
            variantsForSelectedFitOption = [
              ...variantsForSelectedFitOption,
              variant,
            ]
          }
        })

        let availableColorOptions = []
        let availableSizeOptions = []
        let availableFitOptions = []
        variantsForSelectedSizeOption.map((variant) => {
          availableColorOptions = [
            ...availableColorOptions,
            variant.options[colorOptionIndex],
          ]
          availableFitOptions = [
            ...availableFitOptions,
            variant.options[fitOptionIndex],
          ]
        })
        variantsForSelectedColorOption.map((variant) => {
          availableSizeOptions = [
            ...availableSizeOptions,
            variant.options[sizeOptionIndex],
          ]
          availableFitOptions = [
            ...availableFitOptions,
            variant.options[fitOptionIndex],
          ]
        })
        variantsForSelectedFitOption.map((variant) => {
          availableColorOptions = [
            ...availableColorOptions,
            variant.options[colorOptionIndex],
          ]
          availableSizeOptions = [
            ...availableSizeOptions,
            variant.options[sizeOptionIndex],
          ]
        })
        setAvailableColorsForSelectedOption(availableColorOptions)
        setAvailableSizesForSelectedOption(availableSizeOptions)
        setAvailableFitsForSelectedOption(availableFitOptions)
      }
    }
  }, [selectedSize, selectedColor, selectedFit])

  const onAddToCart = async (e) => {
    e.preventDefault()
    setIsAddingCart(true)
    const resCart = await fetch('/cart/add.js', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: selectedVariant.id,
          },
        ],
      }),
    })
    const data = await resCart.json()

    document.getElementById('btn_cart').click()
    setIsAddingCart(false)
    updateCartCount()
  }

  const updateCartCount = async () => {
    const resCart = await fetch('/cart.js', {
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      credentials: 'same-origin',
    })
    const data = await resCart.json()
    document.getElementById('cart_count').textContent = data.item_count
  }

  return (
    <>
      {selectedVariant && (
        <div data-price-wrapper className='product-price' id='product_price'>
          <span data-product-price className='price'>
            ${selectedVariant.price / 100}&nbsp;
          </span>

          {selectedVariant.compare_at_price > selectedVariant.price && (
            <s data-compare-price>${selectedVariant.compare_at_price / 100}</s>
          )}
        </div>
      )}

      <form className='shopify-product-form' onSubmit={onAddToCart}>
        <div className='product-variants-selector'>
          {productData &&
            !isSimpleProduct &&
            productData.options.map((option, i) => (
              <div className='product-variant' key={i}>
                <p className='option-label'>Select {option.name}</p>

                <div
                  name={`options[${option.name}]`}
                  className={`options ${option.name.toLowerCase()}`}
                >
                  {option.name === 'Size' &&
                    option.values.map((value, i) => (
                      <a
                        onClick={() => onSelectSize(value)}
                        className={`${selectedSize === value ? 'active' : ''} ${
                          hasMultipleVariants &&
                          !availableSizesForSelectedOption.includes(value)
                            ? 'disabled'
                            : ''
                        }`}
                        data-value={value}
                        key={i}
                      >
                        {value}
                      </a>
                    ))}
                  {option.name === 'Fit' &&
                    option.values.map((value, i) => (
                      <a
                        onClick={() => onSelectFit(value)}
                        className={`${selectedFit === value ? 'active' : ''} ${
                          hasMultipleVariants &&
                          !availableFitsForSelectedOption.includes(value)
                            ? 'disabled'
                            : ''
                        }`}
                        data-value={value}
                        key={i}
                      >
                        {value}
                      </a>
                    ))}
                  {option.name === 'Color' &&
                    option.values.map((value, i) => (
                      <a
                        onClick={() => onSelectColor(value)}
                        className={`${
                          selectedColor === value ? 'active' : ''
                        } ${
                          hasMultipleVariants &&
                          !availableColorsForSelectedOption.includes(value)
                            ? 'disabled'
                            : ''
                        }`}
                        style={{ backgroundColor: value }}
                        key={i}
                      ></a>
                    ))}
                </div>
              </div>
            ))}
        </div>
        {selectedVariant && selectedVariant.available ? (
          <button type='submit' disabled={isAddingCart}>
            {isAddingCart ? 'Adding to cart' : 'Add to cart'}{' '}
            <span className='arrow'>
              <img src={Arrow} alt='arrow right' />
            </span>
          </button>
        ) : (
          <p className='sold-out'>Sold out</p>
        )}
      </form>
    </>
  )
}

export default AddToCartForm
